<template>
  <div>
    <!-- 封库单 -->
    <!-- EnvironmentNew -->
    <h-list-page class="EnvironmentNew_style">
      <h-card
        :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')"
        width="100%"
        is-search
        @change-method="changeMethod"
      >
        <h-area>
          <h-search :title="h_i18n('226b0912184333c81babf2f1894ec0c1')">
            <h-select
              v-model="searchData.materielCategoryId"
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
              style="width: 196px"
              clearable
              filterable
            >
              <h-option
                v-for="item in data.materielCategoryList"
                :key="item.valueId"
                :label="item.valueName"
                :value="item.valueId"
              >
              </h-option>
              <!-- <h-option key="1" label="数量未确认" value="1227"></h-option>
              <h-option key="2" label="数量已确认" value="1228"></h-option> -->
            </h-select>
          </h-search>
          <h-search :title="h_i18n('7c8421b2dbffef74ba4b169304c8747d')">
            <h-select
              v-model="searchData.flagStatus"
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
              style="width: 196px"
              clearable
              filterable
            >
              <h-option key="1" :label="h_i18n('c6cc397661432878e10a24834460da0d')" value="T"></h-option>
              <h-option key="2" :label="h_i18n('1abbb1748ef98f00486f7801a290fdb4')" value="F"></h-option>
            </h-select>
          </h-search>
          <h-search :title="h_i18n('0039880117c13787732d259f5bc9f7f5')">
            <h-date-picker
              type="daterange"
              v-model="data.luruTime"
              range-separator="-"
              :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')"
              :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')"
              clearable
            ></h-date-picker>
          </h-search>
          <template #operate>
            <h-button
              type="primary"
              :loading="data.tableLoading"
              @click="getInfoList(true)"
            >
              <template #icon>
                <search />
              </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
          </template>
        </h-area>
      </h-card>
      <h-table-card :title="h_i18n('9dff884c419bc5aeaf71071d38fee690')" :h-data="data.dataOfTable">
        <template #buttonGroup>
          <h-button-group>
            <template v-for="item in data.btnListOfSqm" :key="item.code">
              <template v-for="temp in data.btnCodeList" :key="temp">
              <h-button
                v-if="item.code.includes(temp)"
                type="primary"
                :loading="loadingFunction(temp)"
                @click="btnFunction(temp)">
                <i class="iconfont icon-daochu"></i>
                {{ item.name }}</h-button>
            </template>
            </template>
          </h-button-group>
        </template>
        <el-table
          :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')"
          v-loading="data.tableLoading"
          height="540"
          @selection-change="handleSelectionbotChange"
          border
          :data="data.dataOfTable"
          :row-class-name="tableRowClassName"
          size="small"
          style="width: 100%; min-height: 540px"
        >
          <el-table-column prop="rejectsId" :label="h_i18n('ad539fd028219141d81a234286f290a8')" width="180">
            <template #default="{row}">
              <div class="h-global-font--blue" @click="goTempduo(row)">
                {{ row.guarantyNo }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="signDate" :label="h_i18n('6265d095fda40520557a7c9d3a92d2c0')" width="120">
            <template #default="{row}">
              <span>{{ time(row.signDate, 3) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="materielCategoryName"
            :label="h_i18n('383a6d166f8f60e16e726ccc9c483631')"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="inputName"
            :label="h_i18n('ae27d6f465386eb63210704c8918c6c4')"
          ></el-table-column>
          <el-table-column prop="inputDate" :label="h_i18n('0039880117c13787732d259f5bc9f7f5')" width="170">
            <template #default="{row}">
              <span>{{ time(row.inputDate, 6) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="h_i18n('8918869fe13fcc2732d2d225158a8018')">
            <template #default="{row}">
              <!-- "Y":"已提交","S":"待提交" -->
              <span v-if="row.status == 'Y'">{{ h_i18n('f5e626da7e14d2cd3996dcd2627e1c3f') }}</span>
              <span v-else-if="row.status == 'S'">{{ h_i18n('a9c09d3297b708f0ff815a93ec5f4145') }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="reviewName"
            label="审核人"
           
          ></el-table-column> -->
          <el-table-column prop="reviewDate" :label="h_i18n('e6f0708789d7efc02f1a163224ae7fb0')" width="170">
            <template #default="{row}">
              <span>{{ time(row.reviewDate, 6) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reviewResult" :label="h_i18n('8c4ab5982fcea30b260715ac494e7922')">
            <template #default="{row}">
              <!-- "W":"待审核","P":"通过","F":"打回" -->
              <span v-if="row.reviewResult == 'W'">{{ h_i18n('5cb424765cb101866f47ca115605ce3b') }}</span>
              <span v-else-if="row.reviewResult == 'P'">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</span>
              <span v-else-if="row.reviewResult == 'F'">{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="flagStatus" :label="h_i18n('7c8421b2dbffef74ba4b169304c8747d')">
            <template #default="{row}">
              <!-- "T":"有效","F":"无效" -->
              <span v-if="row.flagStatus == 'T'">{{ h_i18n('c6cc397661432878e10a24834460da0d') }}</span>
              <span v-else-if="row.flagStatus == 'F'">{{ h_i18n('1abbb1748ef98f00486f7801a290fdb4') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')"
            width="120"
            class-name="table_button_style"
          >
            <template #default="{row}">
              <!-- <h-button type="primary" size="mini" @click="goTempduo(row)">查看</h-button>
              <h-button type="primary" size="mini" @click="goTempduo(row)">提交</h-button>
              <h-button type="primary" size="mini" @click="goTempduo(row)">修改</h-button> -->
              <div v-if="data.roleFlag == 'S'">
                <div v-if="row.flagStatus == '' || row.flagStatus == null">
                  <div v-if="row.status == 'S'">
                    <div v-if="row.reviewResult == '' || row.reviewResult == null">
                      <h-button type="primary" size="mini" @click="goTempTJ(row)">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
                    </div>
                    <div v-else>
                      <h-button type="primary" size="mini" @click="goTempXG(row)">{{ h_i18n('8347a927c09a4ec2fe473b0a93f667d0') }}</h-button>
                    </div>
                  </div>
                  <div v-else>
                    <h-button type="primary" size="mini" @click="goTempduo(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</h-button>
                  </div>
                </div>
                <div v-else>
                  <h-button type="primary" size="mini" @click="goTempduo(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</h-button>
                </div>
              </div>
              <div v-else>
                <h-button type="primary" size="mini" @click="goTempduo(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</h-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="getInfoList"
          v-model:currentPage="searchData.pageNo"
          :page-size="10"
          layout="total, prev, pager, next,jumper"
          :total="data.total"
        >
        </el-pagination>
      </h-table-card>
    </h-list-page>
  </div>
</template>


<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, onActivated } from "vue";
import axios from "axios";
import moment from "moment";
import { useRoute } from "vue-router";

const { proxy } = getCurrentInstance();
const route = useRoute();
// 查询条件
const searchData = reactive({
  supplyCode: "", // 供应商代码
  mtlNo: "", // 专用号
  pageNo: 1,
  pageSize: 10,
  queryFlag: "hmqm",
});
const data = reactive({
  name: "", // 用户账号
  nickName: "", // 用户昵称
  tableLoading: false,
  dataOfTable: [], // 列表
  total: 0,
  keepalivestatus: 0,
  multipleSelection: [], // 选中数据
  materielCategoryList: [], // 物料大类列表
  roleCode: "",
  roleFlag: "",
  supplyCode: "",
  supplyName: "",
  trueName: "",
  userName: "",
  exportLoading: false,
  btnCodeList:[
    "mkhl_yhwz_hbcns_export",
  ],
  btnListOfSqm:[],
  luruTime:[]
});
// 按钮事件
const btnFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_yhwz_hbcns_export":
    DC()
    break;
  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_yhwz_hbcns_export":
    return data.exportLoading
  }
}
// 传高度方法
const changeMethod = () => {
  proxy.postThisPageHeight();
};
const handleSelectionbotChange = (val) => {
  data.multipleSelection = val;
  console.log(data.multipleSelection);
};

// 查看详情
const goTempduo = (val) => {
  proxy.$router.push({
    name: "EnvironmentSqmNewXQ",
    query: {
      name: data.name,
      nickName: data.nickName,
      supplyCode: data.supplyCode,
      supplyName: data.supplyName,
      trueName: data.trueName,
      username: data.username,
      roleCode: data.roleCode,
      envId: val.envId,
      dataFrom: "sqm",
    },
  });
};

// 提交
const goTempTJ = (val) => {
  proxy.$router.push({
    name: "EnvironmentSqmNewTJ",
    query: {
      name: data.name,
      nickName: data.nickName,
      supplyCode: data.supplyCode,
      supplyName: data.supplyName,
      trueName: data.trueName,
      username: data.username,
      roleCode: data.roleCode,
      envId: val.envId,
      dataFrom: "sqm",
    },
  });
}

// 修改
const goTempXG = (val) => {
  proxy.$router.push({
    name: "EnvironmentSqmNewXG",
    query: {
      name: data.name,
      nickName: data.nickName,
      supplyCode: data.supplyCode,
      supplyName: data.supplyName,
      trueName: data.trueName,
      username: data.username,
      roleCode: data.roleCode,
      envId: val.envId,
      dataFrom: "sqm",
    },
  });
}

// 查询
const getInfoList = (flag) => {
  if (true == flag) {
    searchData.pageNo = 1;
  }
  let params = { ...searchData };
  console.log('搜索所诉讼luruTime',data.luruTime)
  if (data.luruTime&&data.luruTime.length>0) {
    params.beginDateOne = moment(data.luruTime[0]).format("YYYY-MM-DD");
    params.endDateOne = moment(data.luruTime[1]).format("YYYY-MM-DD");
    
  }
  
  data.tableLoading = true;
  proxy
    .$http({
      // /environment/searchModelPageList
      url: "/base/environmentWithHMQM/listPage",
      method: "post",
      data: {
        ...params,
        supplyCode: data.supplyCode,
        queryFlag: "sqm",
      },
    })
    .then((res) => {
      console.log(res, "列表查询");
      data.tableLoading = false;
      if (res.data.data.records) {
        data.dataOfTable = res.data.data.records;
        data.total = res.data.data.total;
        data.tableLoading = false;
      } else {
        data.dataOfTable = [];
        data.tableLoading = false;
        proxy.warning({
          message: res.data.msg ? res.data.msg : h_i18n('21efd88b67a39834582ad99aabb9dc60'),
          title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770'),
        });
      }
    })
    .catch((err) => {
      data.dataOfTable = [];
      data.tableLoading = false;
      proxy.warning({ message: err ? err : h_i18n('0d66ed02d74d0bd89431d6d59533ffb3'), title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
    });
};
// 导出
const DC = () => {
  if (data.total > 5000) {
      proxy.warning(
        { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
        {
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => { },
        }
      );
      return;
    }
    let params = { ...searchData };
    console.log('爱吃有过一次哥哥原创歌词',data.luruTime)
    if (data.luruTime&&data.luruTime.length>0) {
      params.beginDateOne = moment(data.luruTime[0]).format("YYYY-MM-DD");
      params.endDateOne = moment(data.luruTime[1]).format("YYYY-MM-DD");
      
    }
    data.exportLoading = true;
    proxy.startLoading(h_i18n('a69e1d06cbc6803fa5cf49e9966e549e'));
    proxy.httpFile(
      {
        method: "post",
        url: "/base/environmentWithHMQM/exportEnvironmentList",
        data: {
          ...params,
          supplyCode: data.supplyCode,
          queryFlag:'sqm',
        },
      },
      h_i18n('db60bdf4b728c2156567e41540625334')
    ).then(res=>{
      data.exportLoading = false;
    }).catch(err=>{
      data.exportLoading = false;
      proxy.closeLoading()
    })
}
// 获取物料大类
const getMaterielCategories = () => {
  proxy
    .$http({
      method: "get",
      url: "/base/basicData/getMaterielCategories",
      headers: { "content-type": "application/json" },
      params: {
        name: data.name,
        nickName: data.nickName,
        userCode: data.name,
      },
    })
    .then((res) => {
      console.log(res, "getMaterielCategories");
      data.materielCategoryList = res.data.data.map((el) => {
        return {
          valueId: el.materielCategoryId,
          valueName: el.materielCategoryName,
        };
      });
    });
};
onMounted(() => {
  if (route.query) {
    data.supplyCode = route.query.supplyCode;
    data.supplyName = route.query.supplyName;
    data.trueName = route.query.trueName;
    data.username = route.query.username;
    data.roleCode = route.query.roleCode;
    if(data.roleCode.indexOf("H") == 0) {
      if(data.supplyCode != "") {
        data.roleFlag="SN";
      }
    } else {
      if(data.roleCode == "S009"){//只有质量经理才能修改
        data.roleFlag="S";
      }else{
        data.roleFlag="SN";
      }
    }
    console.log(data.roleFlag)
    data.userName = route.query.userName;
  }
  if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
    let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
      }
    })
  }
  getInfoList(); // 查询列表
  getMaterielCategories(); // 查询物料大类
});
onActivated(() => {
  if (data.keepalivestatus == 0) {
    // console.log("首次打开");
    data.keepalivestatus++;
  } else {
    proxy.postThisPageHeight();
    // console.log("操作完之后打开");
    getInfoList();
  }
});
</script>

<style lang="scss">
.EnvironmentNew_style {
  .haier-card .haier-card--body .el-table tr td {
    padding: 11.1px 0;
  }
  .el-table td.textalignleft_style .cell {
    text-align: left !important;
  }
  #addVisible {
    .haier-dialog {
      top: 6%;
    }
  }
  .table_button_style {
    padding: 7px 0 !important;
  }
}
.planHidden {
  display: none;
}
.el-table .warning-row td {
  background-color: #e0e0e0 !important;
}
</style>